import { useMemo } from 'react'

import { SectionTitle } from '../../../../UiBlocks'
import { decodeHtml, LABELS } from '../../../lib'
import { useProduct } from '../../../state'

/**
 * Description component - presentational only
 * Loading state is handled by parent (ProductDetails)
 * Note: dangerouslySetInnerHTML is used for CMS content - content is sanitized server-side
 */
export function Description() {
  const { description, product } = useProduct()

  const decodedDescription = useMemo(() => {
    return description ? decodeHtml(description) : null
  }, [description])

  if (!decodedDescription) {
    return null
  }

  return (
    <div className="react-css bg-white xl:mb-5 mb-2 mt-5" id="productDescription">
      <div className="bg-cards-bg text-text-color">
        <SectionTitle size="sm" align="left" className="px-10 leading-[50px] mb-0">
          {LABELS.productDetails}
        </SectionTitle>
      </div>
      <div className="p-3 border-2 border-solid border-cards-bg flex flex-col items-start">
        <div className="flex justify-center items-center">
          <SectionTitle
            as="h2"
            size="base"
            align="left"
            className="font-sec-font tracking-wider flex flex-row justify-start gap-5 w-full"
          >
            <span className="font-bold text-left text-2xl">{product?.name}</span>
          </SectionTitle>
        </div>
        {/* Content from Magento CMS - sanitized server-side */}
        <div
          className="font-sec-font text-text-color text-xl xl:text-2xl w-full"
          dangerouslySetInnerHTML={{ __html: decodedDescription }}
        />
      </div>
    </div>
  )
}
